import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LoadingService } from './loading.service';
import { Subscription, tap } from 'rxjs';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent implements OnInit, OnDestroy {

  private _subscription = new Subscription();

  @Input()
  show: boolean = false;

  constructor(
    private _srv: LoadingService
  ) {
  }

  ngOnInit() {
    this._subscription.add(
      this._srv.visible$
        .pipe(tap(value => this.show = value))
        .subscribe()
    );
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
